import {
  IconBoard,
  IconUser,
  AppPicker as USBLAppPicker,
} from '@bbl-digital/snorre'
import {
  AppPicker,
  AppPickerAppEnum,
  Button,
  GlobalSearchShortcut,
  Header,
  IconClose,
  IconMenu,
  TopBar,
} from '@bbl-digital/snorre-v2'
import Notifications from 'App/Layout/shared/Notifications'
import { AnimatePresence, motion } from 'motion/react'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { getLogo, isUsbl } from 'shared/utils/theme'
import MenuLayout from '../../MenuLayout'
import { Img } from './styles'

import { useTheme } from '@emotion/react'
import { useAuth } from 'Auth/shared/hooks/useAuth'
import {
  getBbl,
  getBblDisplayNames,
  getBblSettings,
  getBblUrls,
} from 'shared/store/bbl/selectors'
import { getUser } from 'shared/store/user/selectors'
import { cn } from 'shared/utils/cn'
import User from '../shared/User'

const TopLayoutMobile: React.FC = () => {
  const authContext = useAuth()
  const location = useLocation()
  const theme = useTheme()

  const { data: bbl } = useSelector(getBbl)
  const { myPageShort, portalShort } = useSelector(getBblDisplayNames)
  const urls = useSelector(getBblUrls)
  const settings = useSelector(getBblSettings)
  const { data: user } = useSelector(getUser)

  const mypageUrl = bbl?.settings?.urls?.myPage

  const [open, setOpen] = useState<boolean>(false)

  useEffect(() => {
    setDocumentStyles(open)
  }, [open])

  useEffect(() => {
    setOpen(false)
  }, [location.pathname])

  const onMenuToggle = () => setOpen(() => !open)

  const setDocumentStyles = (isOpen: boolean) => {
    if (isOpen) {
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
    } else {
      document.body.style.position = 'unset'
      document.body.style.width = 'unset'
    }
  }

  const goToProfile = () => {
    if (!urls?.myPage) return
    window.location.replace(
      `${urls.myPage}${urls.myPage.endsWith('/') ? '' : '/'}profil?returnUrl=${
        window.location.href
      }`
    )
  }

  const logout = () => {
    const bbl_redirect = settings?.afterLogoutRedirectUrl || ''
    authContext.signOutRedirect({
      post_logout_redirect_uri: window.location.origin + '/portal/afterlogout',
      bbl_redirect,
    })
  }

  return (
    <>
      <TopBar dark={!!open} className={!open ? 'bg-surface-common-subtle' : ''}>
        <div className="flex flex-col gap-md">
          <div className="flex items-center justify-between w-full gap-sm">
            <TopBar.Slot>
              {open ? (
                <Header level={2} size="small" className="text-text-invert">
                  Meny
                </Header>
              ) : (
                <Link to={'/'}>
                  <Img alt="logo" src={getLogo()} />
                </Link>
              )}
            </TopBar.Slot>

            <TopBar.Slot className="flex items-center self-center justify-between gap-sm">
              {user && (
                <User
                  dark={!!open}
                  user={user}
                  onLogout={logout}
                  onGoToProfile={goToProfile}
                />
              )}
              <Notifications dark={!!open} />

              <TopBar.Slot>
                <Button
                  variant={open ? 'nostyle' : 'icon-backgrounded'}
                  onClick={onMenuToggle}
                  className={cn(
                    open &&
                      'w-[36px] h-[36px] flex justify-center items-center '
                  )}
                  trackingName="Topbar"
                  trackingEvent={'Mobil meny: ' + (open ? 'close' : 'open')}
                  focusable
                >
                  {open ? (
                    <IconClose className="text-text-invert" />
                  ) : (
                    <IconMenu />
                  )}
                </Button>
              </TopBar.Slot>
            </TopBar.Slot>
          </div>
          {open && (
            <>
              <TopBar.Slot className="flex flex-col items-center gap-md">
                <GlobalSearchShortcut
                  variant="topnav-mobile-dark"
                  text="Søk i portalen"
                  className="max-w-[450px] [&>span]:!text-global-search-shortcut-topnav-mobile-dark"
                />

                {!isUsbl() && (
                  <AppPicker
                    variant="dark"
                    withPortal
                    selected={{ value: AppPickerAppEnum.Portalen }}
                  >
                    <AppPicker.App
                      label={portalShort}
                      value={AppPickerAppEnum.Portalen}
                      href={'/'}
                    />
                    {mypageUrl && (
                      <AppPicker.App
                        label={myPageShort}
                        value={AppPickerAppEnum.MinSide}
                        href={mypageUrl}
                      />
                    )}
                  </AppPicker>
                )}

                {isUsbl() && (
                  <div
                    className={cn('flex gap-xs my-md  w-full justify-center')}
                  >
                    <USBLAppPicker
                      small={false}
                      href="/"
                      label={portalShort}
                      icon={<IconBoard color={theme.primary} />}
                      lightTheme={false}
                      selected
                    />

                    {mypageUrl && (
                      <USBLAppPicker
                        small={false}
                        label={myPageShort}
                        href={mypageUrl}
                        icon={<IconUser size="30px" color="white" />}
                        lightTheme={false}
                        className="mysite-shortcut"
                      />
                    )}
                  </div>
                )}
              </TopBar.Slot>
            </>
          )}
        </div>
      </TopBar>
      <AnimatePresence>
        {open && (
          <motion.div
            className={cn(
              'fixed  left-0 right-0 bottom-0 bg-white overflow-y-auto z-[100]',
              isUsbl() ? 'top-[210px]' : 'top-[180px]'
            )}
            initial={{ height: 0 }}
            animate={{ height: 'auto' }}
            exit={{ height: 0 }}
            transition={{ duration: 0.2 }}
          >
            <MenuLayout open={open} />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default TopLayoutMobile
